import { api } from '@/fsd/shared/api';
import { IAccountCabinetMembership } from '../../model/types/IAccountCabinetMembership';

export const getAccountCabinetMembership = async (): Promise<
  IAccountCabinetMembership[] | undefined
> => {
  try {
    const data = await api.get<IAccountCabinetMembership[]>(
      '/api/v1/account/cabinet/membership/'
    );

    return data;
  } catch (e) {
    console.error('Ошибка при получении сотрудников:', e);
    return;
  }
};
